import React, { CSSProperties } from 'react';
import clsx from 'clsx';
import styles from './Spinner.module.css';

import d from './d';

export interface BitIconSpinnerProps {
  className?: string;
  s?: CSSProperties;
}

const BitIconSpinner = ({ s, className = '' }: BitIconSpinnerProps) => {
  const classes = clsx({
    [styles.container]: true,
    [className]: true,
  });

  return (
    <svg style={s} role="status" className={classes} viewBox="0 0 30 30">
      <path d={d} />
    </svg>
  );
};

export default BitIconSpinner;
